import React from "react"
import { defaultMarkdownElements } from "#/services/markdown"
import { TileProps } from "@carrotfertility/carotene-core"

const legacyColorToSolidColor: Record<string, TileProps["color"]> = {
  lightBlue: "info",
  mintAlternate: "success",
  veryLightCarrotOrange: "primary",
  lightPampas: "default"
}

export const CalloutBox = ({
  backgroundColor,
  title,
  children
}: {
  backgroundColor?: string
  title?: string
  children: React.ReactNode
}): JSX.Element => {
  const solidColor = backgroundColor ? legacyColorToSolidColor[backgroundColor] : undefined
  const tileProps = solidColor ? { color: solidColor } : {}

  return (
    <defaultMarkdownElements.blockquote.component {...defaultMarkdownElements.blockquote.props} {...tileProps}>
      {title && (
        <defaultMarkdownElements.h4.component {...defaultMarkdownElements.h4.props}>
          {title}
        </defaultMarkdownElements.h4.component>
      )}
      <defaultMarkdownElements.p.component {...defaultMarkdownElements.p.props}>
        {children}
      </defaultMarkdownElements.p.component>
    </defaultMarkdownElements.blockquote.component>
  )
}
